<template>
  <div class="full-screen" v-bind:style="{ backgroundImage: 'url(' + `${user.data.otherInfo['bg-img']}` + ')'}">
    <div class="home-donations app-bg-gradient">
    <div class="stars-bg"></div>
    <div class="payment-success">
      <Languages class="languages" v-bind:settings="true"></Languages>
      <Timer v-if='timerStart' :setTime="setTime"></Timer>
      <div class="mosque-name">{{user.data.name}}</div>
      <div class="footer">{{"All Donations are Voluntary , T &amp; C applies" | translate}} </div>
      <div class="donations-status-sec">
        <h3>{{"Thank you for your support" | translate}}</h3>
        <!--<div class="repeat-trans cursor" @click="repeatTransaction()">
            Repeat transaction
        </div>-->
        <!-- <h3>{{"Do you want a receipt?" | translate}}</h3>
        <div class="btns-sec">
          <div class="btn-bg1 retry">
            <div class="btn-bg2">
              <button @click="reciptReq()" class="cursor login">{{"Yes" | translate}}</button>
            </div>
          </div>
          <div class="btn-bg1">
            <div class="btn-bg2">
              <button @click="moveToHome()" class="cursor login">{{"No, thanks" | translate}}</button>
            </div>
          </div>
        </div> -->
      </div>
        <!-- <div class="overlay" v-if="needRecipt">
          <form v-on:submit.prevent='sendRecipt()'>
              <input type="text" v-model="userName" required placeholder="Your Name"/>
              <input type="email" v-model="email" required placeholder="Email Id"/>
              <button class="cursor">{{"Send" | translate}}</button>
          </form>
          <div v-if="emailStatus">
            <div class="backdrop">
              <div>{{emailStatus.message}}</div>
            </div>
          </div>
        </div> -->
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Timer from './timer.vue'
import Languages from './Languages'

export default {
  data () {
    return {
      amount: null,
      donationName: null,
      needRecipt: false,
      userName: null,
      email: null,
      setTime: null,
      timerStart: true,
      tid: null,
      paymentId: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'token',
      'emailStatus'
    ])
  },
  methods: {
    ...mapActions([
      'changeLoadingStatus',
      'sendMail',
      'resetEmailStatus'
    ]),
    moveToHome () {
      localStorage.removeItem('payment-status')
      localStorage.removeItem('payment-req-status')
      localStorage.removeItem('donation-type')
      localStorage.removeItem('donation-amount')
      localStorage.removeItem('email-status')
      this.resetEmailStatus()
      this.$router.push({path: `/${this.tid}/donations`})
    },
    sendRecipt () {
      let userName = this.userName
      let email = this.email
      let donationType = this.donationType
      let donationAmount = this.donationAmount
      if (this.userName && this.email) {
        this.sendMail({userName, email, donationType, donationAmount}).then((res) => {
          if (res.status === 'Success') {
            setTimeout(() => {
              this.moveToHome()
            }, 3000)
          } else {}
        })
        .catch((error) => {
          console.log(error)
        })
      }
    },
    reciptReq () {
      this.$router.push({path: `/${this.tid}/receipt/${this.donationName}/${this.amount}/${this.paymentId}`})
    }
  },
  components: {
    Timer,
    Languages
  },
  mounted: function () {
    this.donationName = this.$route.params.donationType
    this.amount = this.$route.params.donateAmount
    this.tid = this.$route.params.terminalId
    this.paymentId = this.$route.params.paymentId
    this.setTime = 0.08
    this.$nextTick(() => {
      // Check wether the user has been already logged in.
      if (!this.token) {
        this.$router.push({path: `/${this.tid}/`})
      } else {
        this.changeLoadingStatus(false)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .home-donations {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
  .mosque-name {
    font-size: 40px;
    color: #FFF;
    font-family: "Lato";
    font-weight: bold;
    text-shadow: 1px 1.732px 4px rgba( 0, 0, 0, 0.45 );
    margin-top: 61px;
    margin-bottom: 50px;
    letter-spacing: 2px;
    text-align: center;
  }
  .donations-status-sec {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 200px);
    flex-direction: column;
  }
  .donations-status-sec h3 {
    color: #880913;
    font-size: 26px;
    font-weight: 600;
    margin: 0;
    margin-bottom: 15px;
  }
  .donations-status-sec h3 .errormsg {
    font-size: 32px;
  }
  .btn-bg1 {
    margin-top: 30px;
  }
  .retry {
    margin-right: 30px;
  }
  .btns-sec {
    display: flex;
  }
  .payment-success {
    z-index: 2;
  }
.full-screen {
  background-position: 50%;
}
  div[dir='rtl'] .retry {
    margin-right: initial;
    margin-left: 30px;
  }
@media only screen and (min-width: 2000px) {
  .donations-status-sec h3 {
    font-size: 110px;
    margin-bottom: 10%;
    letter-spacing: 6px;
  }
  .donations-status-sec h3 .errormsg {
    font-size: 110px;
  }
  .donations-status-sec {
    height: 70vh;
  }
  .btn-bg1 {
    margin-top: 200px;
    z-index: 2;
    width: 620px !important;
    height: 200px !important;
    border-radius: 200px;
  }
  .btn-bg2 {
    width: 607px;
    height: 187px;
    border-radius: 200px;
  }
  button {
    width: 594px;
    height: 178px;
    border-radius: 200px;
    font-size: 70px;
    letter-spacing: 3px;
  }
  .retry {
    /* margin-right: 5%; */
  }
  .btns-sec {
    width: 40vw;
  }
  div[dir='rtl'] .retry {
    margin-right: initial;
    margin-left: 5%;
  }
}
@media screen and (min-width: 1200px) and (min-height: 904px) {
  .donations-status-sec {
    height: 70vh;
  }
  .btn-bg1 {
    width: 190px;
    height: 64px;
    min-height: 64px;
  }
  .btn-bg2 {
    width: 182px;
    height: 56px;
  }
  button.login {
    width: 180px;
    height: 54px;
    font-size: 20px;
  }
}

@media screen and (min-width: 1200px) and (min-height: 904px) {
  .btn-bg1 {
    width: 190px;
    height: 64px;
    min-height: 64px;
  }
  .btn-bg2 {
    width: 182px;
    height: 56px;
  }
  button.login {
    width: 180px;
    height: 54px;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/thanks-giving.vue